import React from 'react';
import {
  // Button,
  Typography
} from '@material-ui/core';

const ServerError = () => {
  return (
    <div
      style={{
        width: '100%',
        height: '75vh',
        alignItems: 'center',
        justifyContent: 'center',
        display: 'flex',
        flexDirection: 'column'
      }}
    >
      <Typography>
        Something went wrong. Please contact Collabrix support at &nbsp;
        <a
          href="mailto:support@collabrix.co"
          rel="noopener noreferrer"
          target="_blank"
        >
          support@collabrix.co
        </a>
        . Thank you!
      </Typography>
      {/* <Button
        variant="contained"
        color="primary"
        type="button"
        style={{ marginTop: "1rem" }}
        onClick={() => window.location.reload()}
      >
        Try Again
      </Button> */}
    </div>
  );
};

export default ServerError;
